'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PasswordConfirmer = function () {
  function PasswordConfirmer() {
    _classCallCheck(this, PasswordConfirmer);

    this.restrict = 'A';
    this.require = 'ngModel';
    this.scope = {
      originalPassword: '=passwordConfirmer'
    };

    /**
     * Link
     * @param  {Object} scope
     * @param  {Object} element
     * @param  {Object} attrs
     * @param  {Array} requiredCtrls
     * @return {Void}
     */
    this.link = function (scope, element, attrs, modelCtrl) {
      modelCtrl.$validators.confirmPassword = function (modelValue) {
        return modelValue == scope.originalPassword || !modelValue;
      };

      scope.$watch('originalPassword', function () {
        modelCtrl.$validate();
      });
    };
  }

  /**
   * Factory
   * @return {Object}
   */


  _createClass(PasswordConfirmer, null, [{
    key: 'directiveFactory',
    value: function directiveFactory() {
      PasswordConfirmer.instance = new PasswordConfirmer();
      return PasswordConfirmer.instance;
    }
  }]);

  return PasswordConfirmer;
}();

exports.default = PasswordConfirmer;


/** WEBPACK FOOTER **
 ** ./src/app/directives/formValidators/passwordConfirmer.js
 **/